import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFileNameByPath, isEmptyDash } from "../../constant";
import FileViewerModal from "../common/viewModal.js";
import { onboardingServices } from "../../services/onboardingServices";
import _ from "lodash";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";



function PreviewDoc(props) {
    let navigate = useNavigate();
    const [fileSrc, setFileSrc] = useState();
    const [fileExtension, setFileExtension] = useState("");
    const [fileName, setFileName] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);

    const onNavigateChange = (url) => {
        navigate(url);
    };
    function getFileExtension(filename) {
        return filename.split(".").pop();
    }
    const openModal = (src) => {
        setFileSrc(src);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setFileSrc();
        setIsModalOpen(false);
    };
    const viewMMedia = (data, fileNameParam) => {
        onboardingServices.viewUrlData(data).then(function (response) {
            setFileSrc(response?.data?.data?.url);
            const url = response?.data?.data?.url;
            const filename1 = url?.substring(url.lastIndexOf("/") + 1);
            const filename = filename1?.split("?")[0];
            const extension = getFileExtension(filename);
            setFileExtension(extension);
            setFileName(fileNameParam);
            if (
                extension &&
                (extension == "png" ||
                    extension == "jpg" ||
                    extension == "jpeg" ||
                    extension == "xlsx" ||
                    extension == "xls" ||
                    extension == "csv" ||
                    extension == "docx" ||
                    extension == "doc" ||
                    extension == "pdf")
            ) {
                setIsModalOpen(true);
            } else {
                fetch(url)
                    .then(response => response.blob())
                    .then(blob => {
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = fileNameParam;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    })
                    .catch(error => console.error('Error downloading Doc:', error));
            }
        });
    };

    const displayStyle = () => {
        return {
            display: 'inline-block'
        };
    };

    return (
        <div className="" >
            <div className="images_react_app">
                {props?.data?.key && props.data.key.length > 0 && (
                    <div className="" style={{ textAlign: 'center', width: '100%' }}
                        onClick={() => viewMMedia(props?.data?.key, props?.data?.name)}
                    >
                        <RemoveRedEyeIcon />
                    </div>
                )}
            </div>

            <FileViewerModal
                fileSrc={fileSrc}
                isOpen={isModalOpen}
                onClose={closeModal}
                fileExtension={fileExtension}
                isSubmitCondition={false}
                fileName={fileName}
            />
        </div>
    );
}

export default PreviewDoc;
